<template>
    <vx-card>
      <div class="flex justify-end">
        <vs-button @click="$router.push({name:'org_management'})" color="danger" type="filled" icon-pack="feather" icon="icon-x" class="mr-4">Cancel</vs-button>
        <vs-button color="primary" type="filled" icon-pack="feather" icon="icon-save" @click.prevent="saveForm()">Save</vs-button>
      </div>
  
      <div class="vx-row pt-8">
        <div class="vx-col sm:w-1/2 w-full">
          <div class="vx-row mb-6">
            <div class="vx-col sm:w-1/3 w-full">
              <span>Company Name</span>
            </div>
            <div class="vx-col sm:w-2/3 w-full">
              <vs-input class="w-full" v-model="name" />
              <span class="text-danger text-sm" v-show="error.name != ''">{{error.name}}</span>
            </div>
          </div>
          <div class="vx-row mb-6">
            <div class="vx-col sm:w-1/3 w-full">
              <span>Address</span>
            </div>
            <div class="vx-col sm:w-2/3 w-full">
              <vs-textarea class="w-full" type="text" v-model="address" />
              <span class="text-danger text-sm" v-show="error.address != ''">{{error.address}}</span>
            </div>
          </div>
          <div class="vx-row mb-6">
            <div class="vx-col sm:w-1/3 w-full">
              <span>Phone</span>
            </div>
            <div class="vx-col sm:w-2/3 w-full">
              <vs-input class="w-full" v-model="phone" />
              <span class="text-danger text-sm" v-show="error.phone != ''">{{error.phone}}</span>
            </div>
          </div>
        </div>
      </div>
    </vx-card>
  </template>
  
  <script>
    import api from "@/api";
    
    export default {
      data() {
        return {
          isEdit: false,
          name: "",
          address: "",
          phone: "",
          error: {
            name: "",
            address: "",
            phone: "",
          }
        };
      },
      computed: {
        company() {
          return this.$store.state.currentCompany
        },
      },
      mounted() {
        if(this.$route.params.id) {
          this.isEdit = true
          this.$store.dispatch('updateCurrentCompany', this.$route.params.id)
  
          this.name = this.company.name
          this.address = this.company.address
          this.phone = this.company.phone
        }
      },  
      methods: {
        saveForm() {
          this.error = {
            name: "",
            address: "",
            phone: "",
          };
          if(!this.validateInput()) {
            return;
          }
  
          let params = {
            "name": this.name,
            "address": this.address,
            "phone": this.phone,
            "statusId": 1
          }
  
          if(this.isEdit) {
            params['id'] = this.$route.params.id
          }
  
          this.$vs.loading()
          api.saveCompany(params, this.isEdit)
          .then((result) => result.data)
          .then((data) => {
            this.$vs.loading.close()
            if(!data.status) {
              this.$vs.notify({
                  title:'Error',
                  text: data.message,
                  color:'danger',
                  position:'bottom-center'
              })
            } else {
              this.$vs.notify({
                title:'Success',
                text:'Success save data',
                color:'success',
                position:'bottom-center'
              })
              setTimeout(() => {
                this.$router.push({name:'org_management'})
              },500)
            }
          })
          .catch((e) => {
            console.log(e)
            this.$vs.loading.close()
          });
        },
        validateInput() {
          let error = 0;
          if(this.name == "") {
            this.error.name = "Please input company name"
            error++
          }
          if(this.address == "") {
            this.error.address = "Please input company address"
            error++
          }
          if(this.phone == "") {
            this.error.phone = "Please input phone"
            error++
          }
          return error == 0
        }
      }
    };
    </script>